import request from '@/utils/request'


export function jumpLogin(params) {//跳转登录
  return request({
    url: '/api/oauth/loginValid',
    method: 'get',
    params
  })
}
export function getUserToken(params) {// 携带 code 获取token
  return request({
    url: '/auth/callback',
    method: 'get',
    params
  })
}

export function getUserInfo(data) {//获取用户信息
  return request({
    url: '/api/user/getLoginUser',
    method: 'post',
    data
  })
}
export function userRelated() {//获取用户相关信息
  return request({
    url: '/api/load/get',
    method: 'get',
  })
}
export function userAuth() {//获取用户授权信息
  return request({
    url: 'api/board/enterprise',
    method: 'get',
  })
}


export function dictionaryList() {//字典缓存
  return request({
    url:`/api/dictionary/dictCache`,
    method: 'post',
  })
}
export function dictionaryVersion() {//字典版本号
  return request({
    url:`/api/dictionary/dictCacheVersion`,
    method: 'get',
  })
}
export function dictionaryObj() {//字典对象集合
  return request({
    url:`/api/dictionary/dictCache/list`,
    method: 'post',
  })
}


export function constantList() {//获取常量
  return request({
    url: `/api/constant`,
    method: 'get',
  })
}